import React from "react";
import styled from "styled-components";
import { graphql } from "gatsby";
import { GatsbyImage, getImage } from "gatsby-plugin-image";
import { useIntl, navigate } from "gatsby-plugin-intl";
import get from "lodash/get";

import BaseHeader from "./base";
import KCButton from "Components/KCButton";

const StyledContent = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    position: absolute;
    top: 1rem;
    bottom: 1rem;
    left: 1rem;
    right: 1rem;
    height: 100%:
`;

const StyledSubtitle = styled.div`
  margin-top: 0.8rem;
  text-transform: uppercase;
  font-weight: 600;
  font-size: 1rem;
  text-align: center;
  padding: 0 2rem;

  ${(props) => props.theme.responsive.desktop} {
    width: 40rem;
  }
`;

const StyledCTAWrapper = styled.div`
  padding: 1rem;
  margin-top: 1.2rem;
  display: flex;
  text-align: center;
  &:not(:first-child) {
    margin-left: 0.4rem;
  }
`;

export default function LogoHeader({ logo, subtitle, ctas, ...props }) {
  const intl = useIntl();
  return (
    <BaseHeader {...props}>
      <StyledContent>
        {logo && (
          <GatsbyImage
            alt="logo"
            imgStyle={{
              objectFit: "contain",
              objectPosition: "center bottom",
            }}
            style={{ width: "20rem", height: "6rem" }}
            image={getImage(logo.imageFile)}
          />
        )}
        <StyledSubtitle>{get(subtitle, intl.locale, "")}</StyledSubtitle>
        <StyledCTAWrapper>
          {ctas &&
            ctas.map((cta, i) => (
              <KCButton
                buttonType={cta.type}
                isInvert={props.backgroundColor === "black"}
                key={i}
                label={cta.label[intl.locale]}
                handleClick={() => navigate(cta.link)}
              />
            ))}
        </StyledCTAWrapper>
      </StyledContent>
    </BaseHeader>
  );
}

export const query = graphql`
  fragment logoHeaderModal on STRAPI_ComponentHeaderLogoHeader {
    __typename
    id
    logo {
      url
      imageFile {
        childImageSharp {
          gatsbyImageData(
            placeholder: BLURRED
            formats: AUTO
            layout: FULL_WIDTH
          )
        }
      }
    }
    subtitle {
      en
      es
      it
    }
    textColor {
      color
    }
    ctas {
      label {
        en
        es
        it
      }
      link
      type
    }
    backgroundColor {
      color
    }
    backgroundAsset {
      desktop {
        url
        imageFile {
          childImageSharp {
            gatsbyImageData(
              placeholder: BLURRED
              formats: AUTO
              layout: FULL_WIDTH
              quality: 100
            )
          }
        }
      }
      mobile {
        url
        imageFile {
          childImageSharp {
            gatsbyImageData(
              placeholder: BLURRED
              formats: AUTO
              layout: FULL_WIDTH
              quality: 100
            )
          }
        }
      }
    }
    vimeoURL
  }
`;
